/* eslint-disable react/prop-types */
import { Box, Grid, Link, Paper, TableHead, Typography } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import ApiClass from 'Api/ApiClient';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import classes from 'styles/globalStyle.module.scss';
import { UrlHelpers } from 'urlHelpers/urlHelper';

import ErrorAlert from 'components/ErrorAlert';
import Loader from 'components/Loader/Loader';
import TablePagination from 'components/TablePagination';

import SearchBidirectionalTemplate from './SearchBidirectionalTemplate';

export function BidirectionalTableCellTypography({ children }) {
  return (
    <Typography variant="subtitle2" component="p">
      {children}
    </Typography>
  );
}

BidirectionalTableCellTypography.propTypes = {
  children: PropTypes.node,
};

BidirectionalTableCellTypography.defaultProps = {
  children: <></>,
};

export function BidirectionalTableHeaderTypography({ children }) {
  return (
    <Typography variant="subtitle2" component="p" sx={{ fontWeight: 700 }}>
      {children}
    </Typography>
  );
}

BidirectionalTableHeaderTypography.propTypes = {
  children: PropTypes.node,
};

BidirectionalTableHeaderTypography.defaultProps = {
  children: <></>,
};

const BidirectionalTemplateList = ({ dropDownList = [] }) => {
  const ApiClient = new ApiClass();
  const [biLoader, setBiLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [fullTemplateList, setFullTemplateList] = useState([]);
  const [biApiErr, setBiApiErr] = useState('');
  const [page, setPage] = useState(1);
  let rowsPerPage = 10;
  const paginate = (_, pageNumber) => {
    setPage(pageNumber);
  };
  const indexOfLastPost = page * rowsPerPage;
  const indexOfFirstPost = indexOfLastPost - rowsPerPage;

  const calcUserList = (arr) => {
    return Array.isArray(arr) ? arr?.slice(indexOfFirstPost, indexOfLastPost) : [];
  };

  useEffect(async () => {
    try {
      setBiLoader(true);
      // const resp = await ApiClient.get(UrlHelpers.getTemplateList, {}, 'templateAccessToken');
      const resp = await ApiClient.get(
        `${UrlHelpers.getTemplateList}?templateCategory=bidirectional`,
        {},
        'templateAccessToken'
      );
      setTemplateList(resp);
      setFullTemplateList(resp);
    } catch (e) {
      setBiApiErr(e?.response?.data?.message || 'Error fetching template list');
    } finally {
      setBiLoader(false);
    }
  }, []);

  const onAction = async (fileKey) => {
    console.log('fileKey', fileKey);
    try {
      setBiLoader(true);
      const resp = await ApiClient.post(
        UrlHelpers.fetchPresignedurl,
        {
          fileKey: fileKey,
          templateCategory: 'bidirectional',
        },
        {},
        'templateAccessToken'
      );

      downloadFile(resp?.preSignedUrl, fileKey);
    } catch (e) {
      console.log('e', e);
      setBiApiErr(e?.response?.data?.message || 'Error in download');
    } finally {
      setBiLoader(false);
    }
  };

  const downloadFile = async (url, fileKey) => {
    let filename = fileKey.split('/');
    filename = filename?.[filename?.length - 1] || 'sample';
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      })
      .catch(console.error);
  };

  const TableHeading = ['Type', 'Source', 'File Name', 'Action'];

  return (
    <>
      <Loader open={biLoader} />
      <ErrorAlert biApiErr={biApiErr} setBiApiErr={setBiApiErr} />
      <Grid
        container
        sx={{
          overflowX: 'auto',
          width: '100%',
        }}
      >
        <SearchBidirectionalTemplate
          fullTemplateList={fullTemplateList}
          templateList={templateList}
          setTemplateList={setTemplateList}
          dropDownList={dropDownList}
          setPage={setPage}
        />

        <Paper sx={{ width: '100%', boxShadow: 'none', border: '1px solid rgb(242, 242, 242)' }}>
          <Typography variant="subtitle2" color="secondary" fontWeight="700" m={1}>
            {templateList?.length > 0 &&
              `Showing ${indexOfFirstPost + 1} to ${
                templateList?.length > 9 ? indexOfLastPost : templateList?.length
              } of ${templateList?.length} entries`}
          </Typography>
          <Table aria-label="applications-table">
            <TableHead>
              <TableRow
                sx={{ backgroundColor: '#F2F2F2' }}
                className={classes.tableHeadingApplications}
              >
                {TableHeading?.map((x) => {
                  return (
                    <TableCell key={x}>
                      <BidirectionalTableHeaderTypography>{x}</BidirectionalTableHeaderTypography>
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>

            <TableBody>
              {templateList?.length > 0 &&
                calcUserList(templateList)?.map((row) => (
                  <TableRow
                    key={row?.fileKey}
                    className={classes.tableHeadingApplications}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell>
                      <BidirectionalTableCellTypography>
                        {row?.displayJsontypeCategory}
                      </BidirectionalTableCellTypography>
                    </TableCell>

                    <TableCell width="200">
                      <BidirectionalTableCellTypography display="flex" alignItems="center">
                        {row?.source}
                      </BidirectionalTableCellTypography>
                    </TableCell>

                    <TableCell>
                      <BidirectionalTableCellTypography>
                        {row?.fileName}
                      </BidirectionalTableCellTypography>
                    </TableCell>
                    <TableCell>
                      <BidirectionalTableCellTypography>
                        <Link
                          component="button"
                          variant="subtitle2"
                          color="secondary"
                          onClick={() => onAction(row?.fileKey)}
                        >
                          Download
                        </Link>
                      </BidirectionalTableCellTypography>
                    </TableCell>
                  </TableRow>
                ))}

              {templateList?.length === 0 && (
                <TableRow>
                  <TableCell colSpan={12} sx={{ fontSize: '14px !important', textAlign: 'center' }}>
                    No records found
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Grid>
      <Box sx={{ margin: '15px' }}>
        <TablePagination
          postsPerPage={10}
          totalPosts={templateList?.length}
          paginate={paginate}
          page={page}
        />
      </Box>
    </>
  );
};

export default BidirectionalTemplateList;
